import { isActiveStarsFilter } from "@modules/azm/filter"

const ladiesStarsLogoIntersectionHtml = document.getElementById("ladies-stars-logo-intersection")
const azmContent: HTMLElement | null = document.querySelector(".premium.anzeigen-content")

export function ladiesStarsLogoIntersection(visible: boolean) {
    if (!ladiesStarsLogoIntersectionHtml || !azmContent) {
        return
    }

    if (visible) {
        ladiesStarsLogoIntersectionHtml.classList.remove("hidden")
        azmContent.style.borderBottom = "10px solid #9b507b"
    } else {
        ladiesStarsLogoIntersectionHtml.classList.add("hidden")
        azmContent.style.borderBottom = "none"
    }
}

ladiesStarsLogoIntersection(isActiveStarsFilter())
